import React, { useState, useEffect } from "react";
import { TextField, InputAdornment } from "@material-ui/core";
import Button from "elements/Button";
import { searchIcon, arrowIcon } from "assets/icons";
import useStyles from "./styles";

const AnalyticsList = (props) => {
  const { cardList, currentIndex } = props;

  const {
    RootContainer,
    TitleContainer,
    ButtonContainer,
    buttonStyles,
    buttonStylesDisable,
    title,
    flex1,
  } = useStyles();

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredList, setFilteredList] = useState(cardList || []);

  useEffect(() => {
    if (!searchTerm) {
      setFilteredList(cardList);
    } else {
      const lowerSearch = searchTerm.toLowerCase();
      const newList = cardList.filter((item) => {
        return (
          (item.title && item.title.toLowerCase().includes(lowerSearch)) ||
          (item.licenseNumber &&
            item.licenseNumber.toLowerCase().includes(lowerSearch))
        );
      });
      setFilteredList(newList);
    }
  }, [searchTerm, cardList]);

  const handleListItem = (item, index) => {
    props.handleSelectedListItem(item);
    props.handleCurrentIndex(index);
  };

  const handleAnalytics = () => {
    props.handleAnalytics();
  };

  return (
    <div className={RootContainer}>
      <div className={ButtonContainer}>
        <TextField
          label="Search"
          type="search"
          variant="outlined"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <img src={searchIcon} />
              </InputAdornment>
            ),
          }}
        />
        <Button
          variant="contained"
          handleClick={handleAnalytics}
          buttonStyles={
            currentIndex === null ? buttonStyles : buttonStylesDisable
          }
        >
          OVERALL ANALYTICS
        </Button>
      </div>
      {filteredList?.map((item, index) => {
        return (
          <div
            key={index}
            className={TitleContainer}
            onClick={() => handleListItem(item, index)}
            style={{
              background: index === currentIndex ? "#D0EFFF" : "#ffffff",
              border:
                index === currentIndex
                  ? "1px solid #218AC5"
                  : "1px solid #dcdada",
            }}
          >
            <div className={flex1}>
              <span className={item.licenseNumber ? "" : title}>
                {item.title}{" "}
              </span>
              {item.licenseNumber ? <span>|</span> : ""}
              <span>{item.licenseNumber}</span>
            </div>
            {index === currentIndex ? (
              <img src={arrowIcon} width={"16px"} height={"16px"} />
            ) : (
              ""
            )}
          </div>
        );
      })}
    </div>
  );
};

export default AnalyticsList;
